<template lang="pug">
div.d-none
    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
        thead.thead-light
            tr
                th.text-right(width="12%")
                    span(:title="$t('ui.share_operator')") {{ $t('ui.share_operator') }}
                //- th.text-right(width="10%")
                //-     span(:title="$t('ui.deposit_amount')") {{ $t('ui.deposit_amount') }}
                //- th.text-right(width="10%")
                //-     span(:title="$t('ui.withdrawal_amount')") {{ $t('ui.withdrawal_amount') }}
                th.text-right(width="10%")
                    span(:title="$t('ui.bonus_amount')") {{ $t('ui.bonus_amount') }}
                th.text-right(width="10%")
                    span(:title="$t('ui.adjustment_amount')") {{ $t('ui.adjustment_amount') }}
                th.text-right(width="10%")
                    span(:title="$t('ui.pnl')") {{ $t('ui.pnl') }}
        tbody.clusterize-content
            tr(v-if="tbl.length == 0")
                td(colspan="6").text-center
                    span {{ $t('message.no_data_available') }}
            tr(v-for="(item, index) in tbl")
                td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.share_operator)" :title="$n(item.share_operator, 'currency')") {{ $n(item.share_operator, 'currency') }}
                //- td.text-right
                //-     span.font-weight-bold(:class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                //- td.text-right
                //-     span.font-weight-bold(:class="$helpers.fontClassName(item.withdrawal_amount)" :title="$n(item.withdrawal_amount, 'currency')") {{ $n(item.withdrawal_amount, 'currency') }}
                td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.bonus_amount)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.adjustment_amount)" :title="$n(item.adjustment_amount, 'currency')") {{ $n(item.adjustment_amount, 'currency') }}
                td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.pnl)" :title="$n(item.pnl, 'currency')") {{ $n(item.pnl, 'currency') }}
    br
    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId2")
        thead.thead-light
            tr
                th(width="5%")
                    span #
                th(width="8%")
                    span(:title="$t('ui.category')") {{ $t('ui.category') }}
                th(width="12%")
                    span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
                th(width="15%")
                    span(:title="$t('ui.provider_name')") {{ $t('ui.provider_name') }}
                th.text-center(width="5%")
                    span(:title="$t('ui.pt')") {{ $t('ui.pt') }}
                th.text-center(width="5%")
                    span(:title="$t('ui.pt_on')") {{ $t('ui.pt_on') }}
                th.text-right(width="10%")
                    span(:title="$t('ui.share_company')") {{ $t('ui.share_company') }}
                th.text-right(width="10%")
                    span(:title="$t('ui.share_operator')") {{ $t('ui.share_operator') }}
                th.text-right(width="15%")
                    span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                th.text-right(width="15%")
                    span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                th.text-right(width="15%")
                    span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
            tbody.clusterize-content
                tr(v-if="tbl2.length == 0")
                    td(colspan="11").text-center
                        span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in tbl2")
                    td.text-center
                        span(:title="index + 1") {{ index + 1 }}
                    td
                        span(:title="item.category") {{ item.category }}&nbsp;
                    td
                        span(:title="item.provider_code") {{ item.provider_code }}&nbsp;
                    td
                        span(:title="item.provider_name" v-if="item.provider_name != null") {{ item.provider_name }}&nbsp;
                        div.text-center(v-else) -&nbsp;
                    td.text-center
                        span(:title="$n(item.pt)") {{ $n(item.pt) }}
                    td.text-center
                        span(:title="item.pt_on" v-if="item.pt_on != null") {{ item.pt_on }}
                        span(v-else) -
                    td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(item.share_company)" :title="$n(item.share_company, 'currency')") {{ $n(item.share_company, 'currency') }}
                    td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(item.share_operator)" :title="$n(item.share_operator, 'currency')") {{ $n(item.share_operator, 'currency') }}
                    td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                    td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                    td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                tr.footer
                    td.text-right(colspan="6")
                        span {{ $t("ui.grand_total") }}
                    td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalShareCompany)" :title="$n(grandTotalShareCompany, 'currency')") {{ $n(grandTotalShareCompany, 'currency') }}
                    td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalShareOperator)" :title="$n(grandTotalShareOperator, 'currency')") {{ $n(grandTotalShareOperator, 'currency') }}
                    td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
                    td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                    td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
</template>
<script>
export default {
    props: {
        tbl: {
            type: Array,
            default() {
                return []
            }
        },
        tbl2: {
            type: Array,
            default() {
                return []
            }
        },
        totalTbl: {
            type: Array,
            default() {
                return []
            }
        },
        tblId: {
            type: String,
            default: ""
        },
        tblId2: {
            type: String,
            default: ""
        },
    },
    data: () => ({
        loading: false,
        subTotalWinLose: 0,
        grandTotalWinLose: 0,
        subTotalTurnover: 0,
        grandTotalTurnover: 0,
        subTotalValidTurnover: 0,
        grandTotalValidTurnover: 0,
        subTotalShareCompany: 0,
        grandTotalShareCompany: 0,
        subTotalShareOperator: 0,
        grandTotalShareOperator: 0,
    }),
    watch: {
        tbl(newValue, oldValue) {
            this.getTotal();
        }
    },
    mounted: function () {
        this.getTotal();
    },
    methods: {
        clearTotal() {
            this.subTotalWinLose = 0
            this.grandTotalWinLose = 0
            this.subTotalTurnover = 0
            this.grandTotalTurnover = 0
            this.subTotalValidTurnover = 0
            this.grandTotalValidTurnover = 0
            this.subTotalShareCompany = 0
            this.grandTotalShareCompany = 0
            this.subTotalShareOperator = 0
            this.grandTotalShareOperator = 0
        },
        getTotal: function () {
            this.clearTotal();
            var tbl = this.tbl;
            if (tbl.length > 0) {
                tbl.forEach(value => {
                    this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                    this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                    this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                    this.subTotalShareCompany = parseFloat(this.subTotalShareCompany) + parseFloat(value["share_company"]);
                    this.subTotalShareOperator = parseFloat(this.subTotalShareOperator) + parseFloat(value["share_operator"]);
                });

                var totalTbl = this.totalTbl;
                if (totalTbl.length > 0) {
                    this.grandTotalWinLose = totalTbl[0]["winlose"];
                    this.grandTotalTurnover = totalTbl[0]["turnover"];
                    this.grandTotalValidTurnover = totalTbl[0]["valid_turnover"];
                    this.grandTotalShareCompany = totalTbl[0]["share_company"];
                    this.grandTotalShareOperator = totalTbl[0]["share_operator"];
                }
            }
        }
    }
};
</script>
